import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {FormGroup} from 'react-bootstrap';

const isImage = (accept) => accept.startsWith('image');

export class FileField extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  };
  static defaultProps = {
    accept: 'image/*',
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: null,
      imageUrl: null,
    };
    this.handleChange = this.handleChange.bind(this);

    this.reader = null;
    if (isImage(props.accept)) {
      this.reader = new FileReader();
      this.reader.addEventListener(
        'load',
        () => {
          this.setState({
            imageUrl: this.reader.result,
          });
        },
        false,
      );
    }
  }

  handleChange() {
    const {input, accept} = this.props;
    const file = this.inputRef.files[0];
    input.onChange(file || '');
    this.setState({
      fileName: file instanceof File ? file.name : null,
    });

    if (isImage(accept) && file instanceof File) {
      this.reader.readAsDataURL(file);
    } else if (!(file instanceof File)) {
      this.setState({
        imageUrl: null,
      });
    }
  }

  render() {
    const {fileName, imageUrl} = this.state;
    const {
      id,
      accept,
      input,
      label,
      required,
      helpText,
      meta: {error, warning, touched},
    } = this.props;

    const errorMsg = touched && (error || warning);
    const validationState = (touched && error && 'error') || (warning && 'warning');
    const asterisk = required && <span className="form-field-required" />;

    return (
      <FormGroup validationState={validationState}>
        <input
          ref={(ref) => (this.inputRef = ref)}
          id={id}
          type="file"
          accept={accept}
          className="hidden"
          onChange={this.handleChange}
          tabIndex="-1"
        />
        <Button
          component="label"
          variant="contained"
          color="secondary"
          htmlFor={id}
          onBlur={() => input.onBlur(input.value)}
        >
          {label}
        </Button>
        {asterisk && <span className="small-margin">{asterisk}</span>}
        {helpText && <span className="help-text small-margin">{helpText}</span>}
        {fileName && <span className="small-margin">{fileName}</span>}
        {errorMsg && <span className="help-block small-margin">{errorMsg}</span>}
        {imageUrl && (
          <div className="file-upload-preview">
            <img src={imageUrl} />
          </div>
        )}
      </FormGroup>
    );
  }
}
